import { ReactNode, useState } from 'react'
import { Loader, Stack, Tabs } from '@common/ui'
import { com } from '@eidu/web'
import EntityPicker from '../../../../components/input/EntityPicker'
import RegistryAssetPicker from './RegistryAssetPicker'
import EntityId = com.eidu.entity.EntityId
import EntityTypeKind = com.eidu.entity.type.EntityTypeKind
import entityIdFromString = com.eidu.entity.entityIdFromString

type PickerSource = 'org' | 'registry'

type EntityPickerWithRegistryProps = {
  value: EntityId | undefined
  onChange: (id: EntityId | undefined) => void
  kindFilter: (kind: EntityTypeKind) => boolean
  registryKind?: string
  selectedVersionId?: string
  onRegistryVersionSelect?: (versionId: string) => void
  localPickerExtras?: ReactNode
  hasLocalTypes?: boolean
  valueSource?: PickerSource
  resolvingValueSource?: boolean
  typeLabel?: string
  entityLabel?: string
  noOptionsText?: string
}

const EntityPickerWithRegistry = ({
  value,
  onChange,
  kindFilter,
  registryKind,
  selectedVersionId,
  onRegistryVersionSelect,
  localPickerExtras,
  hasLocalTypes = true,
  valueSource,
  resolvingValueSource = false,
  typeLabel,
  entityLabel,
  noOptionsText,
}: EntityPickerWithRegistryProps) => {
  const [userTab, setUserTab] = useState<PickerSource | undefined>(undefined)
  const tab: PickerSource = userTab ?? valueSource ?? (hasLocalTypes ? 'org' : 'registry')

  const onRegistrySelect = (entityIdString: string, versionId: string) => {
    onChange(entityIdFromString(entityIdString))
    onRegistryVersionSelect?.(versionId)
  }

  const showSpinner = resolvingValueSource && userTab === undefined

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: 528 }}>
      <Tabs value={tab} onChange={(v) => v && setUserTab(v as PickerSource)} mb="md" style={{ flexShrink: 0 }}>
        <Tabs.List>
          {hasLocalTypes && <Tabs.Tab value="org">This organization</Tabs.Tab>}
          <Tabs.Tab value="registry">Registry (cross-org)</Tabs.Tab>
        </Tabs.List>
      </Tabs>
      <div style={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {showSpinner ? (
          <Stack flex={1} align="center" justify="center">
            <Loader />
          </Stack>
        ) : tab === 'org' ? (
          <Stack gap="md" flex={1} style={{ minHeight: 0 }}>
            <EntityPicker
              value={value}
              onChange={onChange}
              kindFilter={kindFilter}
              typeLabel={typeLabel}
              entityLabel={entityLabel}
              noOptionsText={noOptionsText}
            />
            {localPickerExtras}
          </Stack>
        ) : (
          <RegistryAssetPicker
            kind={registryKind}
            selectedEntityId={value?.toString()}
            selectedVersionId={selectedVersionId}
            onSelect={onRegistrySelect}
          />
        )}
      </div>
    </div>
  )
}

export default EntityPickerWithRegistry
